"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSummaryTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.CustomerSummaryTransport = typebox_1.Type.Object({
    order: typebox_1.Type.Object({
        active: typebox_1.Type.Number(),
        completed: typebox_1.Type.Number(),
        total: typebox_1.Type.Number(),
    }),
    invoice: typebox_1.Type.Object({
        open: typebox_1.Type.Number(),
        closed: typebox_1.Type.Number(),
        total: typebox_1.Type.Number(),
    }),
});
//# sourceMappingURL=customer-summary-transport.js.map